import React from 'react';

import {
  t,
} from '../../helpers';

import './Resume.css';

const About = () => (
  <section id="resume" className="download-section content-section text-center">
    <div className="overlay" />
    <div className="container">
      <div className="col-lg-8 mx-auto">
        <h2>{t('resume.title')}</h2>
        <p>{t('resume.text')}</p>
        <a
          href="static/files/CV-Ludovic_Radoux-2018-web.pdf"
          target="_blank"
          rel="noopener noreferrer"
          className="btn btn-default btn-lg"
        >
          {t('resume.buttons.download')}
        </a>
        <p className="resume-alt">
          {t('resume.alt')}{' '}
          <a
            href="static/files/CV-Europass-2018-LRadoux-EN-web.pdf"
            target="_blank"
            rel="noopener noreferrer"
          >
            {t('resume.altLink')}
          </a>
        </p>
      </div>
    </div>
  </section>
);

export default About;



// WEBPACK FOOTER //
// ./src/components/Resume/index.js